export const menuData = [
    {
        name: 'Makanan Indonesia (Indonesian Food)',
        items: [
            { name: 'Ayam Penyet Goreng', price: 30000 },
            { name: 'Ayam Bakar', price: 20000 },
            { name: 'Ayam Goreng Pop', price: 20000 },
            { name: 'Ayam Jingkrak', price: 30000 },
            { name: 'Ayam Penyet Bakar', price: 30000 },
            { name: 'Ayam Cabe Ijo', price: 30000 },
            { name: 'Ayam Goreng Mentega', price: 35000 },
            { name: 'Bebek Penyet Bakar', price: 40000 },
            { name: 'Bebek Penyet Goreng', price: 40000 },
        ]
    },
    {
        name: 'Nasi Goreng',
        items: [
            { name: 'Nasi Goreng Original', price: 30000 },
            { name: 'Nasi Goreng Kampung', price: 30000 },
            { name: 'Nasi Goreng Kari', price: 35000 },
            { name: 'Nasi Goreng Ayam', price: 30000 },
            { name: 'Nasi Goreng Seafood', price: 35000 },
            { name: 'Nasi Goreng Cabe Ijo', price: 30000 },
            { name: 'Nasi Goreng Kambing', price: 50000 },
            { name: 'Nasi Goreng Pete', price: 35000 },
            { name: 'Nasi Goreng Special', price: 37500 },
            { name: 'Nasi Goreng Ayam Lada Hitam', price: 40000 },
            { name: 'Nasi Goreng Daging Lada Hitam', price: 40000 },
            { name: 'Nasi Goreng Bistik Ayam', price: 27500 },
            { name: 'Nasi Goreng Bistik Daging', price: 27500 },
            { name: 'Nasi Goreng Sate Kecap', price: 27500 },
            { name: 'Nasi Goreng Sate Kacang', price: 50000 },
        ]
    },
    {
        name: 'Japan Food',
        items: [
            { name: 'Chicken Katsu Rice', price: 30000 },
            { name: 'Chicken Karaage Rice', price: 30000 },
            { name: 'Chicken Karaage', price: 35000 },
        ]
    },
    {
        name: 'Italy Food',
        items: [
            { name: 'Spaghetti Chicken Hot', price: 30000 },
            { name: 'Spaghetti Bolognese', price: 25000 },
        ]
    },
    {
        name: 'Steak',
        items: [
            { name: 'Single Chicken Steak', price: 25000 },
            { name: 'Double Chicken Steak', price: 40000 },
        ]
    },
    {
        name: 'Olahan Mie',
        items: [
            { name: 'Mie Goreng/Kuah', price: 30000 },
            { name: 'Mie Goreng/Kuah Seafood', price: 30000 },
            { name: 'Mie Goreng/Kuah Special', price: 35000 },
            { name: 'Mihun Goreng/Kuah', price: 30000 },
            { name: 'Mihun Goreng/Kuah Seafood', price: 30000 },
            { name: 'Mihun Goreng/Kuah Special', price: 35000 },
            { name: 'Kwetiaw Goreng/Kuah', price: 30000 },
            { name: 'Kwetiaw Goreng/Kuah Seafood', price: 30000 },
            { name: 'Kwetiaw Goreng/Kuah Special', price: 35000 },
            { name: 'Ifumie Goreng/Kuah', price: 30000 },
            { name: 'Ifumie Goreng/Kuah Seafood', price: 30000 },
            { name: 'Ifumie Goreng/Kuah Special', price: 35000 },
            { name: 'Indomie Kuah/Goreng', price: 25000 },
            { name: 'Indomie Kuah/Goreng Special', price: 30000 },
            { name: 'Indomie Kuah/Goreng Seafood', price: 35000 },
            { name: 'Mie Daging Lada Hitam', price: 40000 },
            { name: 'Indomie Daging Lada Hitam', price: 37500 },
            { name: 'Indomie Kari Bangladesh', price: 15000 },
            { name: 'Indomie Kari Bangladesh (Ayam)', price: 27500 },
        ]
    },
    {
        name: 'Olahan Daging',
        items: [
            { name: 'Sop Daging', price: 40000 },
            { name: 'Nasi Hotplate Ayam/Daging', price: 40000 },
            { name: 'Tongseng Ayam', price: 37500 },
            { name: 'Tongseng Sapi', price: 42500 },
            { name: 'Tongseng Kambing', price: 45000 },
            { name: 'Sate Lontong Ayam/Daging', price: 275000 },
            { name: 'Sate Hidang', price: 60000 },
        ]
    },
    {
        name: 'Olahan Seafood (Untuk Nila dan Gurami dihitung Perons)',
        items: [
            { name: 'Nila Bakar/Asam Manis/Goreng', price: 15000 },
            { name: 'Gurami Bakar/Asam Manis/Goreng', price: 20000 },
            { name: 'Gembung Bakar/Goreng', price: 27500 }, 
            { name: 'Gembung Tauco/Steam', price: 35000 },
            { name: 'Pari Bakar', price: 35000 },
            { name: 'Pari Taucho', price: 45000 },
            { name: 'Hotplate Seafood', price: 40000 },
            { name: 'Cumi Goreng Tepung', price: 55000 },
            { name: 'Udang Goreng Tepung', price: 60000 },
            { name: 'Cumi Asam Manis/Goreng Mentega/Tauco', price: 55000 },
            { name: 'Udang Asam Manis/Goreng Mentega/Tauco', price: 60000 },
        ]
    },
    {
        name: 'Olahan Sayuran',
        items: [
            { name: 'Capcay Sayur', price: 25000 },
            { name: 'Tauge Ikan Asin', price: 25000 },
            { name: 'Tumis Kankung Terasi', price: 25000 },
            { name: 'Tumis Genjer Terasi', price: 25000 },
            { name: 'Tomyam Seafood', price: 35000 },
        ]
    },
    {
        name: 'Tampah',
        items: [
            { name: 'Nasi Ayam Tampah Bakar', price: 99000 },
            { name: 'Nasi Ayam Tampah Goreng', price: 99000 },
            { name: 'Nasi Seafood Tampah Bakar', price: 150000 },
            { name: 'Nasi Seafood Tampah Goreng', price: 150000 },
        ]
    },
    {
        name: 'Snack/Cemilan',
        items: [
            { name: 'Lalapan', price: 10000 },
            { name: 'Peter Bakar/Goreng', price: 15000 },
            { name: 'Roti Cane Gula', price: 10000 },
            { name: 'Roti Kuah Kari', price: 12500 },
            { name: 'Roti Cane Coklat Keju', price: 15000 },
            { name: 'Roti Cane Susu', price: 12500 },
            { name: 'Rujak Porsi Kecil', price: 15000 },
            { name: 'Rujak Porsi Besar', price: 20000 },
            { name: 'Martabak Telur', price: 20000 },
            { name: 'Martabak Mesir', price: 27500 },
            { name: 'Kari Kambing Kecil', price: 30000 },
            { name: 'Kari Kambing Besar', price: 40000 },
            { name: 'Kentang Goreng', price: 20000 },
            { name: 'Ubi Goreng', price: 15000 },
            { name: 'Tahu & Tempe Goreng', price: 18000 },
            { name: 'Pisang Bakar Cokelat Keju', price: 21000 },
            { name: 'Pisang Goreng Cokelat Keju', price: 22000 },
            { name: 'Mantau Srikaya', price: 21000 },
            { name: 'Jamur Crispy', price: 20000 },
            { name: 'Nugget', price: 20000 },
            { name: 'Sosis', price: 20000 },
            { name: 'Chicken Wings', price: 35000 },
            { name: 'Dimsum Mentai Ayam/Kepiting/Udang', price: 25000 },
        ]
    },
    {
        name: 'Minuman (Tea/Ice Cream/Coffee)',
        items: [
            { name: 'Hot Tea', price: 6000 },
            { name: 'Iced Tea', price: 10000 },
            { name: 'Hot Green Tea', price: 10000 },
            { name: 'Iced Green Tea', price: 15000 },
            { name: 'Hot Lemon Tea', price: 10000 },
            { name: 'Iced Lemon Tea', price: 15000 },
            { name: 'Teh Jahe Sereh', price: 15000 },
            { name: 'Teh Mint', price: 15000 },
            { name: 'Teh Jahe Panas', price: 15000 },
            { name: 'Hot Thai Tea', price: 20000 },
            { name: 'Iced Thai Tea', price: 25000 },
            { name: 'Es Cincau', price: 20000 },
            { name: 'Hot Milo', price: 15000 },
            { name: 'Iced Milo', price: 20000 },
            { name: 'Teh Tarik', price: 20000 },
            { name: 'Teh Jahe Susu Panas', price: 20000 },
            { name: 'Coffee India', price: 15000 },
            { name: 'Coffeemix Hot', price: 15000 },
            { name: 'Coffeemix Iced', price: 20000 },
            { name: 'Luwak White Coffee', price: 15000 },
            { name: 'Luwak White Coffee Iced', price: 20000 },
            { name: 'Espresso', price: 15000 },
            { name: 'Iced Espresso', price: 20000 },
            { name: 'Tubruk Panas', price: 15000 },
            { name: 'Latte Art Hot', price: 20000 },
            { name: 'Latte Art Iced', price: 25000 },
            { name: 'Sanger Panas', price: 20000 },
            { name: 'Sanger Dingin', price: 25000 },
            { name: 'Cappuccino Hot', price: 15000 },
            { name: 'Cappuccino Iced', price: 20000 },
            { name: 'Coffee Brown Sugar Hot', price: 20000 },
            { name: 'Coffee Brown Sugar Iced', price: 22500 },
            { name: 'Vietnam Drip', price: 22000 },
            { name: 'Coffee Lemonade', price: 25000 },
        ]
    },
    {
        name: 'Special Drink',
        items: [
            { name: 'Puding Telur Single', price: 6000 },
            { name: 'Puding Telur Double', price: 12000 },
            { name: 'Teh Susu Telur', price: 20000 },
            { name: 'Teh Susu Telur Dingin', price: 25000 },
            { name: 'Es Kelapa Gelas', price: 20000 },
            { name: 'Es Kelapa Bulat', price: 20000 },
            { name: 'Es Kelapa Jeruk', price: 25000 },
            { name: 'Es Vanilla Coffee Latte', price: 25000 },
            { name: 'Es Mocca Coffee Latte', price: 25000 },
            { name: 'Es Macchiato', price: 25000 },
            { name: 'Matcha', price: 25000 },
            { name: 'Chocolate Frappe', price: 25000 },
            { name: 'Jus Pelangi', price: 27500 },
            { name: 'Sop Buah', price: 25000 },
            { name: 'Es Buah', price: 25000 },
            { name: 'Ice Lychee Tea', price: 25000 },
            { name: 'Ice Cream Chocolate', price: 17500 },
            { name: 'Ice Cream Strawberry', price: 17500 },
            { name: 'Ice Cream Vanilla', price: 17500 },
            { name: 'Ice Cream Cincau', price: 250000 },

        ]
    },
    {
        name: 'Fresh Juice',
        items: [
            { name: 'Jus Alpukat', price: 20000 },
            { name: 'Jus Kuini', price: 20000 },
            { name: 'Jus Jeruk', price: 20000 },
            { name: 'Jus Markisa', price: 20000 },
            { name: 'Jus Terong Belanda', price: 20000 },
            { name: 'Jus Belimbing', price: 20000 },
            { name: 'Jus Semangka', price: 20000 },
            { name: 'Jus Nanas', price: 20000 },
            { name: 'Jus Timun', price: 20000 },
            { name: 'Jus Apel', price: 20000 },
            { name: 'Jus Wortel', price: 20000 },
            { name: 'Jus Pepaya', price: 20000 },
            { name: 'Jus Tomat', price: 20000 },
            { name: 'Jus Sirsak', price: 25000 },
            { name: 'Jus Buah Naga', price: 20000 },
            { name: 'Jus Sawi Nanas', price: 25000 },
            { name: 'Jus Martabe', price: 25000 },
            { name: 'Jus Jambu Merah', price: 25000 },
            { name: 'Jus Wortel Susu', price: 25000 },
            { name: 'Jus Sirsak Naga', price: 27500 },
        ]
    },
    {
        name: 'Mocktail',
        items: [
            { name: 'Rainbow Mocktail', price: 20000 },
            { name: 'Dragon Mocktail', price: 20000 },
            { name: 'Green Blue', price: 20000 },
            { name: 'Strawberry Lemon', price: 20000 },
            { name: 'Orange Blue', price: 20000 },
            { name: 'Anggur Mint', price: 20000 },
            { name: 'Leci Mocktail', price: 20000 },
            { name: 'Strawberry Leci', price: 20000 },
            { name: 'Lemon Madu', price: 20000 },
            { name: 'Lemon Selasih', price: 20000 },
            { name: 'India Mocktail', price: 20000 },
            { name: 'Sexy Blue', price: 20000 },
            { name: 'Sunkiest Mojito', price: 20000 },
        ]
    },
    {
        name: 'Milkshake',
        items: [
            { name: 'Milky Creamy', price: 25000 },
            { name: 'Milkhshake Dark Choco', price: 25000 },
            { name: 'Milkshake Oreo', price: 25000 },
        ]
    }
];